import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListEntriesResponse, ListEntriesQueryVariables } from '../types';

const listEntriesQuery = gql`
  query OvertimeListEntries($payrollMonth: String!, $userId: String, $baseDays: String) {
    overtimeListEntries(payrollMonth: $payrollMonth, userId: $userId, baseDays: $baseDays) {
      code
      success
      message
      data {
        entries {
          id
          userId
          formulaCardId
          otFormulaCardName
          payrollMonth
          totalOtHours
          totalOtDays
          workingHoursPerDay
          source
          status
          overrideAmount
          overrideBy
          overrideAt
          createdAt
          updatedAt
          computedAmount
        }
        total
      }
    }
  }
`;

const listEntries = (queryVariables: ListEntriesQueryVariables) => {
  return graphQLApi<ListEntriesResponse, ListEntriesQueryVariables>({
    query: listEntriesQuery,
    queryVariables,
  });
};

export default listEntries;
